/**
 * "Install on a phone": a public link to an APK (POST .../artifacts/:name/install-link, valid for 1 hour) as a QR
 * code the phone's camera scans, with the link itself to copy or open.
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, QRCode } from 'antd';
import { createInstallLink } from '../../services/DeviceBuildsService';

export default function InstallQr({ open, onClose, projectId, buildId, name }) {
  const [state, setState] = useState({ loading: true, link: null, error: null });

  useEffect(() => {
    if (!open) { return undefined; }
    let live = true;
    setState({ loading: true, link: null, error: null });
    createInstallLink(projectId, buildId, name)
      .then((link) => { if (live) { setState({ loading: false, link, error: null }); } })
      .catch((error) => { if (live) { setState({ loading: false, link: null, error }); } });
    return () => { live = false; };
  }, [open, projectId, buildId, name]);

  return (
    <Modal destroyOnHidden footer={null} onCancel={onClose} open={open} title="Install on a phone" width={420} zIndex={1200}>
      <div className="devb-qr" data-testid="devb-qr">
        {state.loading ? <p className="devb-muted">Making the link…</p>
          : state.error ? <p className="devb-bad" data-testid="devb-qr-error">{state.error.message || 'The link could not be made.'}</p>
            : (
              <>
                <p className="devb-muted">Scan it with the phone&apos;s camera, then allow installing apps from your browser if Android asks.</p>
                <QRCode data-testid="devb-qr-code" size={220} value={state.link.url} />
                <a className="devb-qr-link" data-testid="devb-qr-link" href={state.link.url} rel="noopener noreferrer" target="_blank">{state.link.url}</a>
                <p className="devb-muted" data-testid="devb-qr-valid">The link is valid for 1 hour.</p>
              </>
            )}
      </div>
    </Modal>
  );
}

InstallQr.propTypes = {
  buildId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  projectId: PropTypes.string.isRequired,
};
